import { useState } from "react";
import {
  ToggleBox,
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownMenuItem,
  SkeletonBase
} from "@unified-checkout/design-system";

import type { IPaymentMethodsTogglesGroup } from "@app/dashboard/types/innerLayout/payment-methods-toggles-group";
import styles from "./payment-methods-toggles-group.module.scss";


export const PaymentMethodsTogglesGroup = ({
  loading,
  currenciesDropdownProps,
  paymentMethodsList,
  integrationsDropdownProps,
  toggleBoxProps,
  tempSelectedMethods,
  setTempSelectedMethods
}: IPaymentMethodsTogglesGroup) => {

  const [selectedCurrency, setSelectedCurrency] = useState(currenciesDropdownProps?.defaultCurrency);

  return (
    <div className={styles["toggles-group-wrapper"]}>
      {
        currenciesDropdownProps &&
        <div className={styles["toggles-group-wrapper__currencies-dd"]}>
          <Dropdown
            label={currenciesDropdownProps.label}
          >
            <DropdownButton
              type="input"
              placeholder={currenciesDropdownProps?.placeholder}
              text={currenciesDropdownProps?.formatCurrency?.(selectedCurrency || '')}
              disabled={loading || currenciesDropdownProps?.disabled}
            />
            <DropdownMenu maxHeight="15rem">
              {
                currenciesDropdownProps.currenciesList?.map((currency, i) => {
                  return (
                    <DropdownMenuItem
                      key={`currency-${currency}-${i}`}
                      text={currenciesDropdownProps?.formatCurrency?.(currency)}
                      selected={selectedCurrency === currency}
                      onClickHandler={() => {
                        setSelectedCurrency(currency);
                        currenciesDropdownProps?.onClickHandler?.(currency);
                      }}
                    />
                  )
                })
              }
            </DropdownMenu>
          </Dropdown>
        </div>
      }
      {
        loading ?
          <div className={styles["toggles-group-wrapper__toggles-group-loader"]}>
            {
              Array.from({ length: 4 }).map((_, index) => (
                <div
                  className={styles["toggles-group-wrapper__toggles-group-loader__skeleton"]}
                  key={`toggles-group-loader-skeleton-${index}`}
                >
                  <SkeletonBase width="3rem" height="2rem" />
                  <SkeletonBase width="11.25rem" height="1.5rem" />
                  <SkeletonBase width="2.875rem" height="2rem" />
                </div>
              ))
            }
          </div>
          :
          paymentMethodsList && !!Object.keys(paymentMethodsList).length ?
            <div className={styles["toggles-group-wrapper__toggles-group"]}>
              {
                paymentMethodsList && !!Object.keys(paymentMethodsList).length &&
                Object.entries(paymentMethodsList).map((paymentMethod, i) => {
                  const [gatewayName, integrations] = paymentMethod as any;
                  const hasOneIntegration = integrations?.length === 1;

                  const toggleText = toggleBoxProps.getToggleText(gatewayName, integrations, hasOneIntegration);

                  const isToggleChecked = Object.keys(tempSelectedMethods || {}).includes(gatewayName);

                  return (
                    <div
                      className={styles["toggles-group-wrapper__toggles-group__method-box"]}
                      key={`merchant-payment-method-${gatewayName}-${i}`}
                      data-gatewy-has-one-integ={hasOneIntegration}
                    >

                      <div className={styles["toggles-group-wrapper__toggles-group__method-box__method"]}>
                        <ToggleBox
                          type="transparent box"
                          text={toggleText}
                          checked={isToggleChecked}
                          onToggleChangeHandler={(checked) => toggleBoxProps.onToggleChangeHandler?.(checked, gatewayName, integrations, hasOneIntegration)}
                        />
                        <div className={styles["toggles-group-wrapper__toggles-group__method-box__method__icon"]}>
                          {toggleBoxProps.getToggleIcon(gatewayName)}
                        </div>
                      </div>

                      {
                        integrations?.length > 1 && isToggleChecked &&
                        <div className={styles["toggles-group-wrapper__toggles-group__method-box__integrations-box"]}>
                          <Dropdown {...integrationsDropdownProps?.dropdown}>
                            <DropdownButton
                              {...integrationsDropdownProps?.dropdownBtn}
                              text={integrationsDropdownProps?.dropdownBtn?.text?.(gatewayName)}
                            />
                            <DropdownMenu {...integrationsDropdownProps?.dropdownMenu}>
                              {
                                integrations.map((integration: any, index: number) => {
                                  return (
                                    <DropdownMenuItem
                                      key={`merchant-pm-integration-${integration.id}-${index}`}
                                      text={integration.integration_name || integration.id}
                                      selected={tempSelectedMethods?.[gatewayName]?.id === integration.id}
                                      onClickHandler={() => {
                                        setTempSelectedMethods?.(prev => ({
                                          ...prev,
                                          [gatewayName]: {
                                            gatewayName: gatewayName,
                                            id: integration.id,
                                            integrationName: integration.integration_name
                                          }
                                        }));
                                        integrationsDropdownProps?.dropdownMenuItem?.onClickHandler?.(gatewayName, integration);
                                      }}
                                      {...integrationsDropdownProps?.dropdownMenuItem}
                                    />
                                  )
                                })
                              }
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      }
                    </div>
                  )
                })
              }
            </div>
            :
            <></>
      }
    </div>
  )
}
